module.exports = __webpack_public_path__ + "static/media/inventory-boxes.02bd36b3.png";